// extracted by mini-css-extract-plugin
export var countryBorder = "vehicle-forms-module--countryBorder--185ba";
export var feildFlex = "vehicle-forms-module--feildFlex--1a2e4";
export var formContainer = "vehicle-forms-module--formContainer--6fbae";
export var formControlErrorMessage = "vehicle-forms-module--formControlErrorMessage--bdaa8";
export var formControlInput = "vehicle-forms-module--formControlInput--10c47";
export var formControlLabel = "vehicle-forms-module--formControlLabel--14a3b";
export var formSubmitButton = "vehicle-forms-module--formSubmitButton--39b64";
export var inputGroup = "vehicle-forms-module--inputGroup--85b45";